import { useEffect, useRef } from "react";
import Lenis from "lenis";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import PriceTicker from "@/components/PriceTicker";
import Marquee from "@/components/Marquee";
import Chapters from "@/components/Chapters";
import Physical from "@/components/Physical";
import Derivatives from "@/components/Derivatives";
import Logistics from "@/components/Logistics";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";
import VisitingCard from "@/components/VisitingCard";

export default function App() {
  const lenisRef = useRef(null);
  const isCardPage = window.location.pathname === "/card";

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  if (isCardPage) {
    return (
      <div className="bg-[#0A0D12] text-[#F4F6F8] min-h-screen" data-testid="card-root">
        <div className="grain-overlay" aria-hidden="true" />
        <VisitingCard />
        <Toaster theme="dark" position="bottom-right" />
      </div>
    );
  }

  const scrollTo = (hash) => {
    lenisRef.current?.scrollTo(hash, { offset: -72, duration: 1.4 });
  };

  return (
    <div className="bg-[#0A0D12] text-[#F4F6F8] min-h-screen" data-testid="app-root">
      <div className="grain-overlay" aria-hidden="true" />
      <Nav onNavigate={scrollTo} />
      <main>
        <Hero onNavigate={scrollTo} />
        <PriceTicker />
        <Marquee />
        <Chapters />
        <Physical />
        <Derivatives />
        <Logistics />
        <Contact />
      </main>
      <Footer onNavigate={scrollTo} />
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}
